import { render, staticRenderFns } from "./SavePlanDialog.vue?vue&type=template&id=5bf688bf&scoped=true"
import script from "./SavePlanDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SavePlanDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SavePlanDialog.vue?vue&type=style&index=0&id=5bf688bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf688bf",
  null
  
)

export default component.exports